import { useNavigate } from 'react-router-dom';
import TopNavigation from '../../components/feature/TopNavigation';
import BottomNavigation from '../../components/feature/BottomNavigation';
import Card from '../../components/base/Card';

interface Notification {
  id: string;
  title: string;
  message: string;
  type: 'appointment' | 'reminder' | 'offer' | 'system';
  time: string;
  isRead: boolean;
  icon: string;
  color: string;
}

const notifications: Notification[] = [
  {
    id: '1',
    title: 'تذكير بموعد',
    message: 'لديك موعد غداً في الساعة 10:00 ص مع د. أحمد محمد',
    type: 'appointment',
    time: 'منذ ساعة',
    isRead: false,
    icon: 'ri-calendar-check-fill',
    color: '#007AFF'
  },
  {
    id: '2',
    title: 'عرض خاص',
    message: 'خصم 20% على جميع التحاليل المختبرية لفترة محدودة',
    type: 'offer',
    time: 'منذ 3 ساعات',
    isRead: false,
    icon: 'ri-gift-fill',
    color: '#FF3B30'
  },
  {
    id: '3',
    title: 'تم تأكيد الحجز',
    message: 'تم تأكيد حجزك لجلسة العلاج الطبيعي يوم الأحد',
    type: 'appointment',
    time: 'أمس',
    isRead: true,
    icon: 'ri-check-double-line',
    color: '#34C759'
  },
  {
    id: '4',
    title: 'تذكير بالدواء',
    message: 'حان وقت تناول دواء الضغط - الجرعة المسائية',
    type: 'reminder',
    time: 'أمس',
    isRead: true,
    icon: 'ri-capsule-fill',
    color: '#F9A826'
  },
  {
    id: '5',
    title: 'نتائج التحاليل جاهزة',
    message: 'نتائج تحاليل الدم الشاملة أصبحت متاحة للمراجعة',
    type: 'system',
    time: 'منذ يومين',
    isRead: true,
    icon: 'ri-file-text-fill',
    color: '#007AFF'
  },
  {
    id: '6',
    title: 'تحديث في التطبيق',
    message: 'تم إضافة ميزات جديدة لتحسين تجربتك مع تكافل بلس',
    type: 'system',
    time: 'منذ 3 أيام',
    isRead: true,
    icon: 'ri-smartphone-fill',
    color: '#8E8E93'
  }
];

export default function Notifications() {
  const navigate = useNavigate();
  const unreadCount = notifications.filter(n => !n.isRead).length;

  return (
    <div className="min-h-screen bg-gray-50">
      <TopNavigation 
        title="الإشعارات"
        showBack
        onBack={() => navigate('/')}
        rightAction={
          <button className="text-[#007AFF] text-sm font-medium">
            تحديد الكل كمقروء
          </button>
        }
      />
      
      <div className="pt-20 pb-24 px-4 space-y-4">
        {unreadCount > 0 && (
          <div className="bg-[#007AFF]/10 border border-[#007AFF]/20 rounded-xl p-4">
            <div className="flex items-center gap-3">
              <div className="w-8 h-8 bg-[#007AFF] rounded-full flex items-center justify-center">
                <i className="ri-notification-3-fill text-white text-sm"></i>
              </div>
              <div>
                <p className="text-[#007AFF] font-medium text-sm">
                  لديك {unreadCount} إشعار جديد
                </p>
                <p className="text-[#007AFF]/70 text-xs">
                  اضغط على الإشعارات لقراءتها
                </p>
              </div>
            </div>
          </div>
        )}

        <div className="space-y-3">
          {notifications.map((notification) => (
            <Card 
              key={notification.id} 
              padding="md"
              className={`${!notification.isRead ? 'border-r-4 border-r-[#007AFF] bg-[#007AFF]/5' : ''}`}
            >
              <div className="flex gap-4">
                <div 
                  className="w-12 h-12 rounded-full flex items-center justify-center flex-shrink-0"
                  style={{ backgroundColor: `${notification.color}15` }}
                >
                  <i 
                    className={`${notification.icon} text-lg`}
                    style={{ color: notification.color }}
                  ></i>
                </div>
                
                <div className="flex-1 min-w-0">
                  <div className="flex items-start justify-between mb-2">
                    <h3 className={`font-bold text-sm ${!notification.isRead ? 'text-[#333333]' : 'text-[#7A7A7A]'}`}>
                      {notification.title}
                    </h3>
                    <div className="flex items-center gap-2">
                      <span className="text-xs text-[#7A7A7A]">{notification.time}</span>
                      {!notification.isRead && (
                        <div className="w-2 h-2 bg-[#007AFF] rounded-full"></div>
                      )}
                    </div>
                  </div>
                  
                  <p className={`text-sm ${!notification.isRead ? 'text-[#333333]' : 'text-[#7A7A7A]'}`}>
                    {notification.message}
                  </p>
                </div>
              </div>
            </Card>
          ))}
        </div>

        {notifications.length === 0 && (
          <div className="text-center py-16">
            <div className="w-20 h-20 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-notification-off-line text-3xl text-[#7A7A7A]"></i>
            </div>
            <h3 className="font-bold text-[#333333] mb-2">لا توجد إشعارات</h3>
            <p className="text-[#7A7A7A] text-sm">ستظهر إشعاراتك هنا عند وصولها</p>
          </div>
        )}
      </div>
      
      <BottomNavigation />
    </div>
  );
}
